<template>
    <div>
        <b-tabs active-nav-item-class="font-weight-bold text-success-custom"
                active-tab-class="text-success-custom"
                nav-class="location-menu-items-wrap"
                content-class="mt-3">
            <b-tab :title="location.name" v-for="(location, index) in locations"
                   @click="loadMenuItems(location.id)"
                   :key="index">
                <b-table
                    striped
                    hover
                    :show-empty="availableMenuItems.length === 0"
                    :busy.sync="isLoading"
                    small
                    stacked="md"
                    :items="availableMenuItems"
                    :fields="fields"
                    :tbody-tr-class="[rowClass, 'sl-menu-row']"
                    :tbody-class="[rowClass, 'sl-menu-body']"
                    class="order sl-menu-table"
                >
                    <template v-slot:cell(name)="row">
                        <div style="font-size: 18px;">
                            <span
                                :class="{ 'font-weight-bold': true, 'sl-menu-name':true, 'is_maxi': row.item.is_maxi }">{{
                                    row.item.categoryName
                                }}:</span><br>
                            {{ row.value }}
                        </div>
                    </template>
                    <template v-slot:cell(price)="row">
                        <div style="min-width: 55px">
                            {{ row.value }} €
                        </div>
                    </template>
                    <template v-slot:cell(pickedup)="row">
                        <div>{{ row.item.countPreOrderedItems }}/{{ row.item.countPickedItems }}
                        </div>
                    </template>
                    <template v-slot:cell(spontaneous)="row">
                        <div>{{ getExtraMealsPerMenu(row.item.location_id, row.item.location_menu_category_id) }}/{{ row.item.countSpontaneousItems }}</div>
                    </template>
                    <template v-slot:cell(quantity)="row">
                        <div style="min-width: 137px">
                            <b-button pill variant="danger" size="lg"
                                      :disabled="true"
                                      class="font-weight-bold minus sl-button-minus">-
                            </b-button>
                            <div class="quantity mx-2">{{ row.value }}</div>
                            <b-button pill variant="primary" size="lg"
                                      :disabled="true"
                                      class="font-weight-bold plus sl-button-plus">+
                            </b-button>
                        </div>
                    </template>
                    <template v-slot:cell(total)="row">
                        <div class="total">
                            {{ ((row.item.price * 100 * row.item.quantity) / 100).toFixed(2) }} €
                        </div>
                    </template>
                    <template #empty="">
                        <div>
                            <div role="alert" aria-live="polite">
                                <div class="text-center my-2">Es sind keine Aufzeichnungen
                                    vorhanden
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                </b-table>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import {mapGetters, mapState}                  from "vuex";
import {getAllMenuItemsRequest}                from "../../api/menu-items";
import {allVoucherOrders} from "@/utils/helpers";

export default {
    name:       "LocationsMenuItems",
    data() {
        return {
            busy:               false,
            isLoading:          false,
            locationId:         false,
            availableMenuItems: [],
            fields:             [
                {key: 'name', label: 'Name'},
                {key: 'price', label: 'Preis'},
                {key: 'pickedup', label: 'Bestellt/ Abgeholt'},
                {key: 'spontaneous', label: 'Spontan- essen'},
                {key: 'quantity', label: ''},
                {key: 'total', label: 'Summe'},
                {key: 'action', label: ''},
            ],
        }
    },
    methods:  {
        ...mapGetters(['extraMeals', 'limitOrders', 'userLocations']),
        async loadMenuItems(locationId) {
            this.availableMenuItems = [];
            this.isLoading          = true;
            this.locationId         = locationId;
            await this.getAllMenuItems(locationId);
        },
        async getAllMenuItems(locationId) {
            await getAllMenuItemsRequest({locationId: locationId})
                .then(res => {
                    this.availableMenuItems = res.data.map(function (item) {
                        item.quantity = 0;
                        return item;
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        rowClass(item, type) {
            return (item && type === 'row' && item.quantity > 0) ? 'ordered' : null;
        },
        getExtraMealsPerMenu(locationId, locationMenuCategoryId) {
          return allVoucherOrders(this.extraMeals(), parseInt(locationId), locationMenuCategoryId);
        }
    },
    computed: {
        ...mapState(['auth']),
        total() {
            return this.availableMenuItems.length ? this.availableMenuItems.reduce(function (acc, obj) {
                return acc + obj.price * obj.quantity;
            }, 0) : 0;
        },
        locations() {
            let locations = this.auth.userLocations;

            if (locations.length > 0) {
                this.loadMenuItems(locations[0].id);
            }

            return locations;
        }
    },
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/custom_theme";

> > > .location-menu-items-wrap a {
    color: $base-color !important;
}

> > > .location-menu-items-wrap a:hover {
    color: $base-color-hover !important;
}

> > > .order th {
    vertical-align: top;
}

> > > .order tr th div {
    line-height: 18px;
}

> > > .order tr th:nth-child(4) div {
    max-width: 80px;
}

> > > .order tr th:nth-child(5) div {
    max-width: 70px;
}

> > > .order td {
    vertical-align: inherit;
    font-size: 14px;
    padding: 4px;
}

.img-wrapper {
    width: 80px;
}

h3 {
    margin-bottom: 30px;
}

.quantity {
    min-width: 30px;
    display: inline-block;
    text-align: center;
}

.total {
    min-width: 90px;
    display: inline-block;
}

> > > .order tbody tr.ordered {
    background: #f4e1b6;
}

.purchase {
    display: flex;
    justify-content: space-between;
}

> > > .card {
    border-width: 2px;
    border-style: solid;
}

> > > .card.green {
    border-color: $green;
}

> > > .card.yellow {
    border-color: $yellow;
}

> > > .card.red {
    border-color: $red;
}

h4.title {
    position: relative;
    padding-left: 35px;
    font-weight: 700;
    margin-left: 15px;
}

h4.title:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    border-radius: 50%;
}

h4.green {
    border-color: $green;
}

h4.green:before {
    background: $green;
}

h4.yellow {
    color: $yellow;
}

h4.yellow:before {
    background: $yellow;
}

h4.red {
    color: $red;
}

h4.red:before {
    background: $red;
}

> > > .btn-success.disabled, > > > .btn-success:disabled {
    color: #aaaaaa;
    background-color: #aaaaaa;
    border-color: #aaaaaa;
    position: relative;
}

> > > .btn-success.disabled:before,
> > > .btn-success.disabled:after {
    content: '';
    position: absolute;
    width: 40px;
    height: 4px;
    background-color: $red;
    border-radius: 0;
    top: 18px;
    -webkit-transition: 150ms ease-out;
    -moz-transition: 150ms ease-out;
    -o-transition: 150ms ease-out;
    transition: 150ms ease-out;
    z-index: 0;
}


> > > .btn-success.disabled:before {
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    transform: rotate(225deg);
    left: 0px;
}

> > > .btn-success.disabled:after {
    -webkit-transform: rotate(-225deg);
    -moz-transform: rotate(-225deg);
    transform: rotate(-225deg);
    right: 0px;
}

button.minus {
    padding: 5px 16px;
}

button.plus {
    padding: 5px 14px;
}

.round-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    cursor: pointer;
    color: #ffffff;
}

.btn-remove {
    cursor: pointer;
}

> > > .modal-success-title-size {
    font-size: 26px;
    text-align: center !important;

}

> > > .modal-success-text-size {
    font-size: 24px;
    text-align: center !important;
}

.is_maxi {
    background-color: $light-grey !important;
    padding: 4px;
    margin-left: -4px;
    background: border-box;
    border-radius: 5px;
}

</style>
